import { Injectable } from '@angular/core';
import { Router, Resolve, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { SLEntityVersion } from './entity';
import { SLEntityService } from './entity.service';
import { lookupParam } from '../../nav/utils';
import { NotifierService } from '../../ui';

@Injectable()
export class SLEntityVersionResolver implements Resolve<SLEntityVersion> {

  constructor(
    private router: Router,
    private entityService: SLEntityService,
    private notifier: NotifierService,
  ) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): SLEntityVersion | Observable<SLEntityVersion> | Promise<SLEntityVersion> {
    return new Promise<SLEntityVersion>(async (resolve, reject) => {

      let entity_id = lookupParam(route, 'entity_id');
      let entity_version = lookupParam(route, 'entity_version');

      this.notifier.startProgress();

      this.entityService
        .entityVersion(entity_id, parseInt(entity_version, 10))
        .subscribe((entity) => {
          
          if(entity) {
            return resolve(entity);
          }
          else {
            this.router.navigate(['shares-ledger', 'entities']);
            return resolve(null);
          }
        });
    });
  }
}